import { IUserSessionData, UserType } from '../../store/models/user.model';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { SessionService } from '../../store/services/session.service';
import { LeftMenuService } from '../../store/services/left-menu.service';
import { Button, ButtonColor, ButtonSize } from 'app/store/models/button.model';
import { Store } from '@ngrx/store';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { IReducers } from 'app/store/reducers';
import { openDialog } from 'app/store/actions/page.action';
import { InfoTipsComponent } from 'app/dialogs/info-tips/info-tips.component';
import { faQuestionCircle } from '@fortawesome/free-regular-svg-icons';
import { faPaperPlane } from '@fortawesome/free-solid-svg-icons';

@Component({
  selector: 'app-content-listing',
  templateUrl: './content-listing.component.html',
  styleUrls: ['./content-listing.component.scss'],
})
export class ContentListingComponent implements OnInit, OnDestroy {
  properties = {
    content: {
      tooltip:
        'Content Group is where the outbound campaign content is stored. One of the biggest benefits of Retreva is our content strategy so we highly recommend that you work with one of our content experts if you want to edit your campaign content.',
      url: '/contents/content_group',
    },
    response: {
      tooltip:
        'Response Group is where you can edit any of the standard reply actions. Simply select the reply action you want to edit and the next time you use that reply action we will suggest your updated text.<br><b>Warning</b>, do not edit first name or date variables as they pull in automatically in the Cycle, Follow Up and Meeting Reply actions. You can remove them if you do NOT want to use the variables at all.',
      url: '/contents/user_replies',
    },
    signature: {
      tooltip:
        'This is where you can edit your Master Signature. You can update Campaign Signatures separately under each Content Group for Campaigns. Note, this "master" signature is used for ALL reply actions.',
      url: '/accounts/set_signature',
    },
    quick: {
      tooltip:
        'Quick Responses are a great way to store common responses. You can customize up to 20 Quick Responses and easily bring them into your contact replies. This is a great place to store About Us information, marketing materials via links, responses to common objections, etc. After you create your Quick Responses, you can click anywhere in any response dialog box and bring in the correct Quick Response by using the drop down.',
      url: '/contents/quick_responses',
    },
    vsm: {
      url: '/contents/vsm_comments',
    },
  };

  buttonProperties: Button = {
    color: ButtonColor.BLUE,
    size: ButtonSize.SMALL,
    text: 'Edit',
    style: 'filled',
  };

  userSessionData: IUserSessionData;

  componentReady: boolean;

  iconQuestionCircle = faQuestionCircle;
  iconPaperPlane = faPaperPlane;

  private destroy$: Subject<boolean> = new Subject<boolean>();

  constructor(
    private store: Store<IReducers>,
    private leftMenuService: LeftMenuService,
    private sessionService: SessionService,
  ) {
  }

  ngOnInit() {
    this.leftMenuService.expand('content');

    this.sessionService
      .onReady()
      .pipe(takeUntil(this.destroy$))
      .subscribe((sessionData: IUserSessionData) => {
        this.userSessionData = sessionData;

        this.componentReady = true;
      });
  }


  canUserEdit(): boolean {
    if (!this.userSessionData) {
      return false;
    }

    if (this.userSessionData.user_type === UserType.MASTER && this.userSessionData.id !== 1) {
      return false;
    }

    return true;
  }

  ngOnDestroy() {
    this.destroy$.next(false);
  }

  onInfoImageClick() {
    this.store.dispatch(
      openDialog({
        dialogData: {
          content: InfoTipsComponent,
          title: 'Tips',
          canClose: true,
          dialogMinWidth: '700px',
          componentData: {
            type: 'content',
          },
        },
      }),
    );
  }
}
